<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" center @opened="dialogOpen" @closed="dialogClose"
    :append-to-body="true" width="60%" v-loading="loading" element-loading-text="加载中..." :close-on-click-modal="false">
    <el-form class="d2-mr-10 d2-mt-5" ref="form" :model="form" label-width="80px">
      <el-form-item prop="name" label="姓名" :rules="[{ required: true, message: '不能为空', trigger: 'blur'}]">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item prop="tel" label="电话"
        :rules="[{ pattern: /^1[345789]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur', 'change'] }]">
        <el-input v-model="form.tel"></el-input>
      </el-form-item>
      <el-form-item prop="address" label="地址" :rules="[{ required: true, message: '不能为空', trigger: 'blur' }]">
        <el-input v-model="form.address"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogClose">取 消</el-button>
      <el-button type="primary" :loading="loading" @click="saveAddress">保存</el-button>
    </div>
  </el-dialog>
</template>
<script>
  import * as indexService from "@/api/sys/index";
  export default {
    name: "editAddress",
    props: {
      adddata: Object,
      value: Boolean,
    },
    data() {
      return {
        dialogVisible: false,
        loading: false,
        title: '',
        form: {}
      };
    },
    watch: {
      value(val) {
        this.dialogVisible = val;
      },
      dialogVisible(val) {
        this.$emit("input", val);
      },
    },
    computed: {
      unitname() {
        return this.$store.state.d2admin.userInfo.userinfo;
      },
    },
    methods: {
      dialogOpen() {
        this.$refs.form.resetFields();
        if (this.adddata.id) {
          this.form = JSON.parse(JSON.stringify(this.adddata));
          this.title = '编辑收货地址';
        } else {
          this.form = {};
          this.title = '新增收货地址';
        }
      },
      saveAddress() {
        this.$refs["form"].validate(valid => {
          if (valid) {
            this.loading = true;
            let f = this.form;
            let id = this.adddata.id;
            let params = {
              mainData: {
                MemberCode: this.unitname.uInfo.Code,
                ReceiverName: f.name,
                Address: f.address,
                Mobile: f.tel,
              },
              childrenData: [],
              shortTitle: "收货地址表",
              dataId: id ? id : 0,
            }
            indexService.addQuestionData(params).then(data => {
              this.loading = false;
              this.dialogVisible = false;
              this.$emit("submit");
              this.$refs.form.resetFields();
            }).catch(e => {
              this.loading = false;
            });
          } else {
            return false;
          }
        });
      },
      dialogClose() {
        this.$refs.form.resetFields();
        this.dialogVisible = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  /deep/ .el-dialog__body {
    padding: 5px 20px 10px 20px;

    &::-webkit-scrollbar {
      // 是否显示
      display: none;
      width: 6px;
      padding-right: 4px;
      background-color: #fff;
    }

    &::-webkit-scrollbar-thumb {
      -webkit-border-radius: 3px;
      border-radius: 3px;
      background-color: #c6c6c6;
    }
  }

  .sign_checkbox,
  .sign_checkbox /deep/ .el-checkbox__label {
    display: flex;
    align-items: center;
  }

  .sign_checkbox .sign_checkbox {
    flex: 1;
  }

  .sign_checkbox i {
    font-size: 22px;
    color: #7a7a7a
  }
</style>